export default "__VITE_PUBLIC_ASSET__2ea27b59__"